import React from 'react';
import { Shield, Swords, Scale, FileText } from 'lucide-react';

const PHASES = [
  { id: 'briefing', label: 'Intelligence Briefing', icon: Shield, color: 'blue' },
  { id: 'positions', label: 'Opening Positions', icon: Swords, color: 'amber' },
  { id: 'clash', label: 'The Clash', icon: Scale, color: 'red' },
  { id: 'verdict', label: 'The Verdict', icon: FileText, color: 'green' },
];

const colorMap = {
  blue: { active: 'bg-blue-500', ring: 'ring-blue-500/40', text: 'text-blue-400', line: 'bg-blue-500' },
  amber: { active: 'bg-amber-500', ring: 'ring-amber-500/40', text: 'text-amber-400', line: 'bg-amber-500' },
  red: { active: 'bg-red-500', ring: 'ring-red-500/40', text: 'text-red-400', line: 'bg-red-500' },
  green: { active: 'bg-green-500', ring: 'ring-green-500/40', text: 'text-green-400', line: 'bg-green-500' },
};

const DebatePhaseBar = ({ currentPhase, phasesCompleted = [] }) => {
  const currentIdx = PHASES.findIndex(p => p.id === currentPhase);

  return (
    <div className="flex items-center w-full px-2 py-3" data-testid="debate-phase-bar">
      {PHASES.map((phase, idx) => {
        const Icon = phase.icon;
        const colors = colorMap[phase.color];
        const isActive = phase.id === currentPhase;
        const isCompleted = phasesCompleted.includes(phase.id) && !isActive;
        const isFuture = idx > currentIdx && !isCompleted;

        return (
          <React.Fragment key={phase.id}>
            <div className="flex flex-col items-center gap-1 flex-shrink-0">
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center transition-all duration-500 ${
                  isActive
                    ? `${colors.active} ring-4 ${colors.ring} shadow-lg scale-110`
                    : isCompleted
                      ? `${colors.active} opacity-60`
                      : 'bg-gray-700/50 opacity-40'
                }`}
                data-testid={`phase-${phase.id}`}
              >
                {isCompleted ? (
                  <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
                ) : (
                  <Icon className={`w-4 h-4 ${isActive ? 'text-white' : 'text-gray-400'}`} />
                )}
              </div>
              <span className={`text-[10px] font-medium whitespace-nowrap ${isActive ? colors.text : isFuture ? 'text-gray-600' : 'text-gray-500'}`}>
                {phase.label}
              </span>
            </div>
            {idx < PHASES.length - 1 && (
              <div className={`flex-1 h-0.5 mx-1 mt-[-12px] rounded-full transition-all duration-500 ${
                idx < currentIdx ? colors.line + ' opacity-60' : 'bg-gray-700/30'
              }`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default DebatePhaseBar;
